<script lang="ts">
	import type { FaqItem } from "../data/christmasFaqs";
	import FrequentlyAskedQuestion from "./FrequentlyAskedQuestion.svelte";

	export let questionAndAnswers: FaqItem[];

	let openIndex: number | null = null;

	function toggleFaq(index: number): void {
		if (openIndex === index) {
			openIndex = null;
		} else {
			openIndex = index;
		}
	}
</script>

<section class="mt-10 flex flex-col gap-4 md:mt-14 xl:px-[11.5rem]">
	{#each questionAndAnswers as { question, answer, anchor }, index}
		<FrequentlyAskedQuestion
			{question}
			{answer}
			{anchor}
			isOpen={openIndex === index}
			onClick={() => {
				toggleFaq(index);
			}}
		/>
	{/each}
</section>
